import { FormikProps } from "formik"
import { useRef } from "react"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"

import { CreateUpdateDeviceFormNew } from "../components/CreateUpdateDeviceFormNew"
import { CreateDisplayFormValues } from "../deviceTypes"
import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { SuccessDisplay } from "../../../../../../core/api/errorTypes"
import { createRoomDevice } from "../../../../../serviceCenter/report/home/serviceCenterHomeApi"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faShieldCheck } from "@fortawesome/pro-light-svg-icons"
import {
    SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE,
    SERVICE_CENTER_ADMIN_ROUTE,
} from "../../../../../../constants/routes"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import { ServiceCenterDevicesQuery } from "../../../../../serviceCenter/admin/organization/devices/serviceCenterDevicesApi"

import { useNavigate } from "react-router-dom"

export function CreateDevice() {
    const formRef = useRef<FormikProps<CreateDisplayFormValues>>(null)
    const navigate = useNavigate()

    const { mutateAsync: onDeviceCreate } = useApiMutation(createRoomDevice, {
        successDisplay: SuccessDisplay.SNACKBAR,
        async onSuccess(_, __, context) {
            await context.queryClient.invalidateQueries({ queryKey: [ServiceCenterDevicesQuery.DEVICES] })
            navigate(SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE)
        },
    })

    const handleSaveClick = () => formRef.current?.submitForm()

    return (
        <>
            <LocalizedStrict id="service-center-admin-organization-create-devices-title" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_CREATE_ROUTE}
                    title="Devices"
                    icon={<FontAwesomeIcon icon={faShieldCheck} />}
                    rightElement={
                        <LocalizedStrict id={"devices-create-device-form"}>
                            <StandardButton type="submit" onClick={handleSaveClick}>
                                Create
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={SERVICE_CENTER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-organization">
                            <Breadcrumb>Organization</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-organization-devices">
                            <BreadcrumbLink to={SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE}>
                                Devices
                            </BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-organization-devices-create">
                            <Breadcrumb>Create display</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <CreateUpdateDeviceFormNew ref={formRef} onSubmit={onDeviceCreate} />
        </>
    )
}
